import weethIcon from "../../../media/icons/weeth.png";

export function WeETHIcon() {
    return (
        <img src={weethIcon} width={38} height={38} alt='weETH'/>
    )
}
